import { createI18n } from "vue-i18n";

import ENGLISH_TRANSLATIONS from "~/translations/en.json";
import DANISH_TRANSLATIONS from "~/translations/da.json";
import DEV_TRANSLATIONS from "~/translations/dev.json";
9;
export default defineNuxtPlugin({
  name: "translator",
  setup(app) {
    const LANGUAGE_DEFAULT = "da";

    const TRANSLATIONS = {
      "en-gb": ENGLISH_TRANSLATIONS,
      da: DANISH_TRANSLATIONS,
      dev: DEV_TRANSLATIONS,
    };

    const i18n = createI18n({
      locale: getNavLanguage(),
      silentTranslationWarn: true,
      messages: TRANSLATIONS,
    });

    function getNavLanguage() {
      let navLang = navigator.language;
      if (navLang && (navLang.startsWith("en-gb") || navLang.startsWith("en-US"))) {
        return "en-gb";
      }

      return LANGUAGE_DEFAULT;
    }

    app.vueApp.use(i18n);

    return { provide: { i18n } };
  },
});
